import { Pipe, PipeTransform } from '@angular/core';
import { CategoryEnum } from 'src/app/shared/enums/CategoryEnum';
import { IFaqExtended } from 'src/app/shared/interfaces/IFaq';

@Pipe({
  name: 'extendedFaqCategoryFilter',
  standalone: true
})
export class ExtendedFaqCategoryFilterPipe implements PipeTransform {
  transform(questions: IFaqExtended[], categories: (string | CategoryEnum)[]): IFaqExtended[] {
    if (!questions || !categories || !categories.length) {
      return questions || [];
    }
    return questions.filter(
      question => categories.includes(question.siemens?.category) || categories.includes(question.shs?.category) || categories.includes(question.siemensenergy?.category)
    );
  }
}
